import React from "react";
import "../styles/hero.css"; // Hero section specific styles
import heroData from "../data/heroData.json"; // Import JSON data from the data directory

const Hero = () => {
  const { title, description, buttonText } = heroData;

  const scrollToContactUs = () => {
    const contactUsSection = document.getElementById("contact");
    if (contactUsSection) {
      contactUsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <h1>{title}</h1>
        <p>{description}</p>
        <button className="cta-button" onClick={scrollToContactUs}>
          {buttonText}
        </button>
      </div>
    </section>
  );
};

export default Hero;
